// extracted by mini-css-extract-plugin
export default {"container":"InputSearch_container__JZYVn"};